// extracted by mini-css-extract-plugin
export default {"disabled":"UpdateUserStatus_disabled__4o6aH","status":"UpdateUserStatus_status__kG-2a","statusIsActive":"UpdateUserStatus_statusIsActive__7wJmt"};